// =============================================================================
// ŞİRKET BİLGİLERİ — Yasal sayfalar bu dosyadaki bilgileri kullanır.
// LÜTFEN aşağıdaki TODO işaretli alanları gerçek bilgilerle güncelle.
// Bir kez burayı doldurduğunda tüm yasal sayfalar otomatik güncellenir.
// =============================================================================

export const COMPANY = {
  // Ticari unvan (örn: "JUËN Eğlence Hizmetleri Ltd. Şti.")
  legalName: "Hbarel Organizasyon Turizm Ticaret Limited Şirketi",
  brandName: "JUËN",

  // Adres
  address: {
    street: "Uluçınar Mah. Çakır Sk. No:20",
    district: "Arsuz",
    city: "Hatay",
  },

  // İletişim
  email: "info@juen.club", // TODO: gerçek e-posta
  kvkkEmail: "kvkk@juen.club", // TODO: KVKK başvuruları için ayrı e-posta önerilir
  phone: "+90 530 938 90 99",
  // WhatsApp numarası (uluslararası format, sadece rakam)
  whatsapp: "905309389099",

  // Yasal kayıt bilgileri (Limited / Anonim Şirket için zorunlu)
  taxOffice: "TODO: Vergi Dairesi", // örn: "Beyoğlu Vergi Dairesi"
  taxNumber: "TODO: 10 haneli Vergi No",
  tradeRegistryNumber: "TODO: Ticaret Sicil No",
  mersisNumber: "TODO: 16 haneli MERSIS No",
  chamberOfCommerce: "İstanbul Ticaret Odası", // TODO: bağlı olduğun oda

  // Web
  website: "https://juen.club",

  // Mekan / faaliyet
  businessActivity: "Etkinlik organizasyonu, üyelik hizmetleri ve eğlence mekanı işletmeciliği",
};

export function formatAddress() {
  const a = COMPANY.address;
  return `${a.street}, ${a.district}/${a.city}`;
}
